<template>
    <div class="return-wrapper">
    <div class="content-box">
        <div class="wrapper">
            <div class="text">
                <div class="purple">
                        Com objetivo de ajudar no processo de cuidado de<br>
                        sua saúde e no esclarecimento de possíveis dúvidas,<br>
                        o Health Id Lab elaborou algumas dicas e orientações<br>
                        personalizadas de acordo com seu perfil. Confira o<br>
                        conteúdo a seguir e nunca esqueça que a saúde é o<br>
                        seu maior patrimônio.
                </div>
            </div>
            <div class="img">
                <img id="igg-one" src="@/assets/images/return/igg1.png" alt="iggOne.png" v-if="data.kit_type_id == 1" />
                <img id="qt-one" src="@/assets/images/return/qt1.png" alt="qt1.png" v-if="data.kit_type_id == 2" />
            </div>
        </div>
        <div class="wrapper">
            <div class="img margin-ba">
                <img id="igg-two" src="@/assets/images/return/igg2.png" alt="iggTwo.png" v-if="data.kit_type_id == 1"/>
                <img id="qt2-two" src="@/assets/images/return/qt2.png" alt="qt2.png" v-if="data.kit_type_id == 2"/>
            </div>
            <div>
                <div class="purple bold" style="margin-bottom: 15px;" v-if="data.kit_type_id == 1">
                    Você sabia que IgG é uma classe de<br>
                    anticorpos (moléculas de defesa),<br>
                    produzidos pelo corpo especificamente<br>
                    contra uma substância estranha ao<br>
                    organismo, que pode ser um vírus,<br>
                    bactéria ou toxina?
                </div>
                <div class="purple bold" style="margin-bottom: 15px;" v-if="data.kit_type_id == 2">
                    Em relação as vacinas para o<br>
                    Covid-19, ainda há algumas dúvidas sobre o<br>
                    processo de imunização, sua segurança e<br>
                    sua eficácia.
                </div>
                <div class="group bold" style="margin-bottom: 15px;" v-if="data.kit_type_id == 1">
                    <div class="block-bg-2">
                        Para o exame que<br>
                        será realizado,<br>
                        quando o resultado<br>
                        do teste de IgG<br>
                        aparecer como<br>
                        positivo, a indicação é<br>
                        de que a pessoa teve<br>
                        contato com o vírus<br>
                        do COVID-19 e, então,<br>
                        iniciou a produção de<br>
                        anticorpos contra ele.<br>
                    </div>
                    <div class="block-bg-1">
                        Um resultado negativo,<br>
                        por outro lado, se deve<br>
                        ao fato do teste ter sido<br>
                        realizado quando ainda<br>
                        não havia a produção de<br>
                        anticorpos no organismo,<br>
                        o que não significa que<br>
                        a pessoa não tenha tido<br>
                        contato com o vírus, pois<br>
                        pode ter ocorrido a<br>
                        infecção, porém sem<br>
                        tempo suficiente para a<br>
                        produção dos anticorpos.
                    </div>
                </div>
                <div class="group bold" style="margin-bottom: 15px;" v-if="data.kit_type_id == 2">
                    <div class="block-bg-2">
                        Primeiro é importante<br>
                        destacar que, mesmo<br>
                        após as duas doses<br>
                        da vacina, nosso<br>
                        organismo não gera<br>
                        uma resposta imune<br>
                        imediata variando de<br>
                        individuo para<br>
                        indivíduo. Os<br>
                        resultados dos<br>
                        estudos levam em<br>
                        conta dados do 15º<br>
                        dia, após a segunda<br>
                        dose das vacinas.
                    </div>
                    <div class="block-bg-1">
                        Também cabe salientar<br>
                        que a grande eficácia das<br>
                        vacinas ocorre para<br>
                        casos graves. Ou seja,<br>
                        você pode ter a doença<br>
                        mesmo com imunização<br>
                        completa. Neste caso,<br>
                        espera-se que seu<br>
                        organismo esteja mais<br>
                        capacitado a uma<br>
                        resposta otimizada,<br>
                        minimizando as chances<br>
                        de casos graves e<br>
                        excluindo no caso de<br>
                        novas variantes.
                    </div>
                </div>
                <div class="purple" style="margin-bottom: 15px;">
                    Desse modo, é fundamental continuar usando máscara<br>
                    e a fazer distanciamento social seguindo as<br>
                    recomendações dos órgãos competentes.<br>
                </div>
            </div>
        </div>
        <div class="wrapper" v-if="data.disease && data.disease != null">
            <div class="purple disease-text">
                Notamos que você informou {{data.disease}} na pergunta sobre doenças ou condições específicas. 
                Estudos indicam que tal condição inclui você no grupo de risco para o Covid-19.<br><br>
                As principais recomendações para pacientes que tenham comorbidades, 
                estando assim em grupo de risco, é redobrar os cuidados e manter a adoção de medidas preventivas, 
                principalmente o isolamento social, uso da máscara e a higienização constante das mãos com álcool em gel. 
                Outra medida importante é não suspender o tratamento com medicamentos de uso contínuo. 
                Havendo dúvidas com relação ao tratamento de condições preexistentes, converse com o seu médico.
            </div>
            <div class="img margin-ba">
                <img id="igg-1" src="@/assets/images/return/igg1.png" alt="iggTwo.png" v-if="data.kit_type_id == 1"/>
                <img id="qt-1" src="@/assets/images/return/qt1.png" alt="qt1.png" v-if="data.kit_type_id == 2"/>
            </div>
        </div>
        <div class="wrapper" v-bind:class="data.disease && data.disease != null ? 'reverse' : ''">
            <div>
                <div class="green" v-if="data.kit_type_id == 2">
                    Por fim, não esqueça que o tempo de proteção é<br>
                    desconhecido ainda pela Sociedade Científica. A<br>
                    Organização Mundial de Saúde considera aceitável o prazo<br>
                    de 06 (seis) meses.
                </div>
            </div>
        </div>
    </div>

    </div>
</template>

<script>
    import { GET_DOCUMENT } from '../../services/document'

    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faDownload } from '@fortawesome/free-solid-svg-icons'

    library.add(faDownload);

    export default {
        props: {
            data: null
        },
        data() {
            return {
                values: null,
                loading: false
            }
        },
        methods: {
            outsideClick() {
                if(event.target === event.currentTarget)
                    this.$emit('close');
            },
            getLink(type) {
                this.loading = true;
                GET_DOCUMENT(this.data.kitId, type, type == 2 ? this.data.annexDocument : this.data.labDocument)
                    .then(res => {
                        window.open(res.link, '_blank').focus();
                    }).finally(res => {
                        this.loading = false;
                    });
            }
        },
        mounted() {
            console.log(this.data);
        }
    }
</script>

<style scoped>
    .loading-div {
        color: var(--primary-color) !important;
    }

    @import "./return-modal.scss";
    @import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/components/ReturnModal/ReturnModal.vue